import { getRgObjectsOfType as a } from "@project-rouge/rg-core";
import { getPerimeter as f } from "../index8.js";
const l = (e, r) => {
  r && (e = r.flatMap((t) => a(e, t))), "rg" in e && (e = [e]);
  let i = 0;
  for (const t of e)
    i += f(t) * t.size[1];
  return i;
};
export {
  l as getVerticalWallArea
};
//# sourceMappingURL=index59.js.map
